import React from 'react';
import PropTypes from 'prop-types';
import { formatCurrency, formatInterval } from '../../utils/formatters';

/**
 * PlanCard Component
 *
 * Displays a single subscription plan with pricing and features.
 * Extracted from SubscriptionPlans for reusability.
 */
const PlanCard = ({
    plan,
    isCurrentPlan,
    isProcessing,
    hasActiveSubscription,
    onSelect
}) => {
    const handleClick = () => {
        if (!isProcessing && !isCurrentPlan) {
            onSelect(plan);
        }
    };

    // Determine button text
    const getButtonText = () => {
        if (isProcessing) return 'Przetwarzanie...';
        if (isCurrentPlan) return 'Aktualny plan';
        if (hasActiveSubscription) return 'Zmień plan';
        return 'Wybierz';
    };

    return (
        <div
            className={`plan-card ${plan.recommended ? 'recommended' : ''} ${isCurrentPlan ? 'current' : ''}`}
        >
            {plan.recommended && (
                <div className="badge recommended-badge">Polecany</div>
            )}
            {isCurrentPlan && (
                <div className="badge current-badge">Obecny</div>
            )}

            <h2>{plan.name}</h2>

            <div className="price">
                <span className="amount">
                    {formatCurrency(plan.price, plan.currency)}
                </span>
                <span className="period">
                    / {formatInterval(plan.period)}
                </span>
            </div>

            <ul className="features">
                {plan.features.map((feature, index) => (
                    <li key={index}>
                        <span className="check">✔</span>
                        {feature}
                    </li>
                ))}
            </ul>

            <button
                className="select-btn"
                onClick={handleClick}
                disabled={isProcessing || isCurrentPlan}
            >
                {getButtonText()}
            </button>
        </div>
    );
};

PlanCard.propTypes = {
    plan: PropTypes.shape({
        id: PropTypes.string.isRequired,
        priceId: PropTypes.string,
        name: PropTypes.string.isRequired,
        description: PropTypes.string,
        price: PropTypes.number.isRequired,
        currency: PropTypes.string,
        period: PropTypes.string,
        features: PropTypes.arrayOf(PropTypes.string),
        recommended: PropTypes.bool
    }).isRequired,
    isCurrentPlan: PropTypes.bool,
    isProcessing: PropTypes.bool,
    hasActiveSubscription: PropTypes.bool,
    onSelect: PropTypes.func.isRequired
};

PlanCard.defaultProps = {
    isCurrentPlan: false,
    isProcessing: false,
    hasActiveSubscription: false
};

export default PlanCard;
